<div class="buy-container">
  <!-- Browse all ready-made magnets — always visible in finish-order view -->
  <!-- <button *ngIf="isFinishedEditing" class="browse-all-magnets-btn" (click)="onBrowseAllMagnets()">
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
    <circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/>
  </svg>
  {{ 'HOME.PURCHASE_CONTROLS.BROWSE_ALL_MAGNETS' | translate }}
</button> -->


<!-- Main Purchase Button -->
<div class="buy-container-inner" [ngClass]="{'enabled': isFinishedEditing()}">
  <div class="buy-container-inner-quantity">
    <!-- Cart Summary Button (when in cart mode) -->
    @if (hideQuantityControls()) {
      <button class="cart-summary-btn" (click)="toggleCartExpanded()">
        <div class="cart-icon-wrapper">
          <img loading="lazy" width="24" height="24" src="../../assets/images/cart.svg" alt="Cart">
          <span class="cart-badge">{{ totalCartItemCount }}</span>
        </div>
        <div class="cart-summary-info">
          <span class="cart-summary-label">{{ 'HOME.YOUR_CART' | translate }}</span>
        </div>
      </button>
    }

    <!-- Quantity Controls (hidden when hideQuantityControls is true) -->
    @if (!hideQuantityControls()) {
      <div class="buy-container-inner-quantity-button">
        <button [disabled]="!isFinishedEditing()" (click)="decreaseQuantity()">
          <img loading="lazy" width="16" height="16" src="../../assets/images/Minus.svg" alt="">
        </button>
        <span>{{quantity()}}</span>
        <button [disabled]="!isFinishedEditing()" (click)="increaseQuantity()">
          <img loading="lazy" width="16" height="16" src="../../assets/images/Plus.svg" alt="">
        </button>
      </div>
    }

    <button (click)="onBuyNow()" [disabled]="!isFinishedEditing() || isProcessingOrder()" class="buy-now-button">
      <div class="price-container">
        <!-- Compare at price (strikethrough) -->
        @if (hasCompareAtPrice) {
          <div class="compare-price">
            <span class="compare-price-amount">{{currentCompareAtPrice.toFixed(2)}} {{currency}}</span>
          </div>
        }
        <!-- Total price -->
        <div class="total-price">
          <span class="price-amount">{{currentTotalPrice.toFixed(2)}} {{currency}}</span>
        </div>
      </div>
    </button>
  </div>
</div>
</div>

<!-- Cart Modal Backdrop -->
@if (isCartExpanded) {
  <div class="pc-cart-modal-backdrop" (click)="toggleCartExpanded()"></div>
}

<!-- Cart Modal -->
<div class="pc-cart-modal" [class.pc-cart-modal--open]="isCartExpanded" role="dialog" aria-modal="true">
  <div class="pc-cart-modal-header">
    <h3 class="pc-cart-modal-title">{{ 'HOME.YOUR_CART' | translate }}</h3>
    <button class="pc-cart-modal-close" (click)="toggleCartExpanded()" aria-label="Close">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M15 5L5 15M5 5L15 15" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
      </svg>
    </button>
  </div>

  <div class="pc-cart-modal-body">
    <!-- Custom Designs Section -->
    @if (designs().length > 0) {
      <div class="pc-cart-modal-section">
        <h4 class="pc-cart-modal-section-title">{{ 'HOME.CUSTOM_MAGNETS' | translate }}</h4>
        @for (design of designs(); track design; let i = $index) {
          <div class="pc-cart-modal-item">
            <div class="pc-cart-modal-item-thumb">
              <img [src]="design.thumbnailUrl" alt="Design {{i + 1}}">
            </div>
            <div class="pc-cart-modal-item-info">
              <span class="pc-cart-modal-item-name">{{ 'HOME.DESIGN' | translate }} #{{i + 1}}</span>
              <span class="pc-cart-modal-item-price">{{ formatProductPrice((design.quantity * basePricePerUnit).toString(), currency) }}</span>
            </div>
            <div class="pc-cart-modal-item-qty">
              <button (click)="onUpdateDesignQuantity(design.id, design.quantity - 1)" [disabled]="design.quantity <= 1">
                <img loading="lazy" width="16" height="16" src="../../assets/images/Minus.svg" alt="-">
              </button>
              <span>{{design.quantity}}</span>
              <button (click)="onUpdateDesignQuantity(design.id, design.quantity + 1)">
                <img loading="lazy" width="16" height="16" src="../../assets/images/Plus.svg" alt="+">
              </button>
            </div>
            <div class="pc-cart-modal-item-actions">
              <button class="pc-action-btn pc-action-edit" (click)="onEditDesign(design.id)" aria-label="Edit">
                <img loading="lazy" width="18" height="18" src="../../assets/images/edit.svg" alt="Edit">
              </button>
              <button class="pc-action-btn pc-action-delete" (click)="onRemoveDesign(design.id)" aria-label="Delete">
                <img loading="lazy" width="18" height="18" src="../../assets/images/delete.svg" alt="Delete">
              </button>
            </div>
          </div>
        }
        <button class="pc-add-another-btn" (click)="onAddAnotherDesign()">
          <span class="plus-icon">+</span>
          {{ 'HOME.ADD_ANOTHER_DESIGN' | translate }}
        </button>
      </div>
    }

    <!-- Shopify Products Section -->
    @if (hasShopifyProducts) {
      <div class="pc-cart-modal-section">
        <h4 class="pc-cart-modal-section-title">{{ 'HOME.SHOPIFY_PRODUCTS_CART' | translate }}</h4>
        @for (item of shopifyProducts; track item) {
          <div class="pc-cart-modal-item">
            <div class="pc-cart-modal-item-thumb">
              <img [src]="item.product.imageUrl" [alt]="item.product.title">
            </div>
            <div class="pc-cart-modal-item-info">
              <span class="pc-cart-modal-item-name">{{item.product.title}}</span>
              <span class="pc-cart-modal-item-price">{{ formatProductPrice((+item.product.price.amount * item.quantity).toString(), item.product.price.currencyCode) }}</span>
            </div>
            <div class="pc-cart-modal-item-qty">
              <button (click)="onUpdateShopifyProductQuantity(item.product.id, item.quantity - 1)" [disabled]="item.quantity <= 1">
                <img loading="lazy" width="16" height="16" src="../../assets/images/Minus.svg" alt="-">
              </button>
              <span>{{item.quantity}}</span>
              <button (click)="onUpdateShopifyProductQuantity(item.product.id, item.quantity + 1)">
                <img loading="lazy" width="16" height="16" src="../../assets/images/Plus.svg" alt="+">
              </button>
            </div>
            <button class="pc-action-btn pc-action-delete" (click)="onRemoveShopifyProduct(item.product.id)" aria-label="Remove">
              <img loading="lazy" width="18" height="18" src="../../assets/images/delete.svg" alt="Remove">
            </button>
          </div>
        }
      </div>
    }
  </div>

  <div class="pc-cart-modal-footer">
    <div class="pc-cart-modal-total">
      <span class="pc-cart-modal-total-label">{{ 'HOME.TOTAL' | translate }}</span>
      <span class="pc-cart-modal-total-amount">{{currentTotalPrice.toFixed(2)}} {{currency}}</span>
    </div>
    <button class="pc-cart-modal-checkout-btn" (click)="onBuyNow()" [disabled]="isProcessingOrder()">
      {{ 'HOME.BUY_NOW' | translate }}
    </button>
    <!-- <button class="pc-cart-modal-continue-btn" (click)="onContinueShopping()">
    {{ 'HOME.CONTINUE_SHOPPING' | translate }}
  </button> -->
  <button class="pc-cart-modal-browse-btn" (click)="onBrowseAllMagnets()">
    {{ 'HOME.PURCHASE_CONTROLS.BROWSE_ALL_MAGNETS' | translate }}
  </button>
</div>
</div>

<!-- Delete Confirmation Modal -->
@if (showDeleteConfirmation) {
  <div class="confirmation-modal" [class.show]="showDeleteConfirmation">
    <div class="modal-content">
      <h4>{{ 'HOME.DELETE_CONFIRMATION.TITLE' | translate }}</h4>
      <p>{{ 'HOME.DELETE_CONFIRMATION.MESSAGE' | translate }}</p>
      <div class="modal-actions">
        <button class="btn-secondary" (click)="cancelDeleteConfirmation()">{{ 'HOME.CANCEL' | translate }}</button>
        <button class="btn-primary" (click)="confirmRemoveDesign()">{{ 'HOME.DELETE_CONFIRMATION.CONFIRM' | translate }}</button>
      </div>
    </div>
  </div>
}

<!-- Edit Confirmation Modal -->
@if (showEditConfirmation) {
  <div class="confirmation-modal" [class.show]="showEditConfirmation">
    <div class="modal-content">
      <h4>{{ 'HOME.EDIT_CONFIRMATION.TITLE' | translate }}</h4>
      <p>{{ 'HOME.EDIT_CONFIRMATION.MESSAGE' | translate }}</p>
      <div class="modal-actions">
        <button class="btn-secondary" (click)="cancelEditConfirmation()">{{ 'HOME.CANCEL' | translate }}</button>
        <button class="btn-primary" (click)="confirmEditDesign()">{{ 'HOME.EDIT_CONFIRMATION.CONFIRM' | translate }}</button>
      </div>
    </div>
  </div>
}

<!-- Delete Shopify Product Confirmation Modal -->
@if (showDeleteProductConfirmation) {
  <div class="confirmation-modal" [class.show]="showDeleteProductConfirmation">
    <div class="modal-content">
      <h4>{{ 'HOME.DELETE_PRODUCT_CONFIRMATION.TITLE' | translate }}</h4>
      <p>{{ 'HOME.DELETE_PRODUCT_CONFIRMATION.MESSAGE' | translate }}</p>
      <div class="modal-actions">
        <button class="btn-secondary" (click)="cancelDeleteProductConfirmation()">{{ 'HOME.CANCEL' | translate }}</button>
        <button class="btn-primary" (click)="confirmRemoveShopifyProduct()">{{ 'HOME.DELETE_PRODUCT_CONFIRMATION.CONFIRM' | translate }}</button>
      </div>
    </div>
  </div>
}
